/**
 * Returns true if the device used is Android
 */
export function isAndroidDevice(): boolean {
  return !!navigator.userAgent.match(/Android/i);
}

/**
 * Returns true if the device used is iOS
 */
export function isIOSDevice(): boolean {
  return !!navigator.userAgent.match(/iPhone|iPad|iPod/i);
}
